import states from "./states"
import { UPDATE_JOURNEY_ANALYTICS_STATE } from "./actiontypes"

const journey_analytics_details = (
  state = states.journey_analytics_details,
  action
) => {
  switch (action.type) {
    case UPDATE_JOURNEY_ANALYTICS_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export default journey_analytics_details
